export default "__VITE_ASSET__ca023bf5__"